import { render, staticRenderFns } from "./amazoSage.vue?vue&type=template&id=423d5752&scoped=true"
import script from "./amazoSage.vue?vue&type=script&lang=js"
export * from "./amazoSage.vue?vue&type=script&lang=js"
import style0 from "./amazoSage.vue?vue&type=style&index=0&id=423d5752&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423d5752",
  null
  
)

export default component.exports